import dayjs from 'dayjs';

type DateInput = string | Date;

const FORMATS = {
  dateTime: 'DD/MM/YYYY HH:mm',
  dateTimeShort: 'D MMM HH:mm',
  dateOnly: 'DD/MM/YYYY',
  dateOnlyLong: 'D MMM YYYY',
  timeOnly: 'HH:mm',
  timeOnlyLong: 'HH:mm:ss',
  hourOnly: 'HH',
  weekdayNarrow: 'dd',
  weekdayWithDate: 'ddd D MMM'
} as const;

export const formatDate = (value: DateInput, variant: keyof typeof FORMATS = 'dateTime'): string =>
  dayjs(value).format(FORMATS[variant]);

export const getBrowser12HourTime = (): boolean =>
  new Intl.DateTimeFormat(navigator.language, { hour: 'numeric' }).resolvedOptions().hour12 ?? false;
